import * as Sentry from '@sentry/browser';
import Storage from './Storage';

const Log = {
    info: function(message, action, data) {
        Sentry.withScope(scope => {
            scope.setLevel('info');
            scope.setTag('action', action);
            scope.setUser({ 'id': Storage.getItem(Storage.KEY_UNIQUE_USER_ID) })

            if (data) {
                data.forEach(function(item) {
                    Object.keys(item).forEach(function(key) {
                        scope.setExtra(key, item[key]);
                    });
                });
            }

            Sentry.captureMessage(message);
        });
    },

    exception: function(message, action, data) {
        Sentry.withScope(scope => {
            scope.setLevel('fatal');
            scope.setTag('action', action);
            scope.setUser({ 'id': Storage.getItem(Storage.KEY_UNIQUE_USER_ID) })
            
            if (data) {
                data.forEach(function(item) {
                    Object.keys(item).forEach(function(key) {
                        scope.setExtra(key, item[key]);
                    });
                });
            }

            Sentry.captureException(message);
        });
    },
}

export default Log;


// WEBPACK FOOTER //
// ./scripts/util/Log.js